exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.orbit-panel[data-v-404887d4] {\n  width: 30%;\n  top: calc(var(--header-height, 56px) + 8px);\n  max-height: calc(100vh - var(--header-height, 56px) - 8px);\n}\n", ""]);

